<div class="main-content">
  <!-- Content Area -->
  <div class="content-area p-6">
    <!-- Back Button -->
    <!-- <div class="back-section">
        <button 
          pButton 
          type="button" 
          icon="pi pi-arrow-left" 
          label="Back to Routing Slip"
          class="p-button-text"
          (click)="onBack()">
        </button>
      </div> -->

    <!-- Header Section -->
    @if (!loading && routingSlipDetails) {
    <div class="header-container">
      <!-- Title Section -->
      <div class="title-section">
        <button (click)="onBack()" class="back-button">
          <i class="pi pi-arrow-left text-gray-600 text-sm"></i>
          <h1 class="document-title">
            {{ documentName || routingSlipDetails.documentName }}
          </h1>
          <!-- Status for mobile and tablet -->
          <div class="status-indicator mobile-status">
            <span
              class="status-badge"
              [ngClass]="
                statusPillClass(
                  getStatusDescriptionText(routingSlipDetails.statusDescription)
                )
              "
            >
              {{ getStatusDescriptionText(routingSlipDetails.statusDescription) }}
            </span>
          </div>
        </button>

        <!-- Status for desktop -->
        <div class="status-indicator desktop-status">
          <span
            class="status-badge"
            [ngClass]="
              statusPillClass(
                getStatusDescriptionText(routingSlipDetails.statusDescription)
              )
            "
          >
            {{ getStatusDescriptionText(routingSlipDetails.statusDescription) }}
          </span>
        </div>

        <!-- Buttons for mobile and tablet (inside title section) -->
        <div class="buttons-section mobile-buttons">
          <div class="button-group">
            <!-- Audit Log Button - Always show -->
            @if (showAuditButton) {
            <p-button
              class="buttons-details"
              [label]="isMobile ? '' : 'View Audit Log'"
              icon="pi pi-list"
              (onClick)="onViewAuditsLog()"
            ></p-button>
            }

            <!-- Comment Button - Show based on permission -->
            @if (showCommentButton) {
            <p-button
              class="buttons-details"
              [label]="isMobile ? '' : 'Comment'"
              icon="pi pi-comment"
              (onClick)="onComment()"
            ></p-button>
            }

            <!-- Approve Button - Show based on permission -->
            @if (showApproveButton) {
            <p-button
              class="button-approve"
              [label]="isMobile ? '' : 'Approve'"
              icon="pi pi-check"
              [disabled]="isDocuSignSigningInProgress"
              (onClick)="onApprove()"
            ></p-button>
            }

            <!-- Reject Button - Show based on permission -->
            @if (showRejectButton) {
            <p-button
              class="button-reject"
              [label]="isMobile ? '' : 'Reject'"
              icon="pi pi-times"
              (onClick)="onReject()"
            ></p-button>
            }

            <!-- Mark as Viewed Button - Show for Secretary/Manager with ViewOnly permission -->
            @if (showMarkAsViewedButton) {
            <p-button
              class="button-approve"
              [label]="
                isMobile ? '' : isMarkedAsViewed ? 'Viewed' : 'Mark as Viewed'
              "
              icon="pi pi-eye"
              (onClick)="onMarkAsViewed()"
              pTooltip="Clicking this will approve your status to Viewed"
              tooltipPosition="top"
            ></p-button>
            }

            <!-- Archive Button - Always show -->
            @if (showArchiveButton) {
            <p-button
              class="buttons-details"
              [label]="isMobile ? '' : 'Archive'"
              icon="pi pi-trash"
              (onClick)="onDelete()"
            ></p-button>
            }
          </div>
        </div>
      </div>

      <!-- Buttons Section for desktop -->
      <div class="buttons-section desktop-buttons">
        <div class="button-group">
          <!-- Audit Log Button - Always show -->
          @if (showAuditButton) {
          <p-button
            class="buttons-details"
            label="View Audit Log"
            icon="pi pi-list"
            (onClick)="onViewAuditsLog()"
          ></p-button>
          }

          <!-- Comment Button - Show based on permission -->
          @if (showCommentButton) {
          <p-button
            class="buttons-details"
            label="Comment"
            icon="pi pi-comment"
            (onClick)="onComment()"
          ></p-button>
          }

          <!-- Approve Button - Show based on permission -->
          @if (showApproveButton) {
          <p-button
            class="button-approve"
            label="Approve"
            icon="pi pi-check"
            [disabled]="isDocuSignSigningInProgress"
            (onClick)="onApprove()"
          ></p-button>
          }

          <!-- Reject Button - Show based on permission -->
          @if (showRejectButton) {
          <p-button
            class="button-reject"
            label="Reject"
            icon="pi pi-times"
            (onClick)="onReject()"
          ></p-button>
          }

          <!-- Mark as Viewed Button - Show for Secretary/Manager with ViewOnly permission -->
          @if (showMarkAsViewedButton) {
          <p-button
            class="button-approve"
            [label]="isMarkedAsViewed ? 'Viewed' : 'Mark as Viewed'"
            icon="pi pi-eye"
            (onClick)="onMarkAsViewed()"
            pTooltip="Clicking this will approve your status to Viewed"
            tooltipPosition="top"
          ></p-button>
          }

          <!-- Archive Button - Always show -->
          @if (showArchiveButton) {
          <p-button
            class="buttons-details"
            label="Archive"
            icon="pi pi-trash"
            (onClick)="onDelete()"
          ></p-button>
          }
        </div>
      </div>
    </div>
    }

    <!-- Loading State -->
    @if (loading) {
    <div class="loading-container">
      <div class="loading-spinner">
        <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
        <p>Loading routing slip details...</p>
      </div>
    </div>
    }

    <!-- Content redesigned with Tailwind utilities -->
    @if (!loading && routingSlipDetails) {
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
      <!-- Left: Assigned Users -->
      <div class="lg:col-span-2">
        <div class="bg-white border border-gray-200 rounded-lg p-4">
          <div class="space-y-6">
            @if (assignedUserLevels.length > 0) {
            @for (lvl of assignedUserLevels; track lvl.level) {
            <div class="p-4 border border-gray-200 rounded-lg bg-gray-50 flex flex-col">
              <!-- Level header -->
              <div class="flex items-start justify-between gap-3 mb-3">
                <div class="flex items-center gap-3 flex-1 min-w-0">
                  <h4 class="text-sm font-medium text-gray-700 whitespace-nowrap">
                    Level: {{ lvl.level }}
                  </h4>
                  <div class="flex items-center gap-2 flex-1 min-w-0">
                    <span class="text-sm font-medium text-gray-700 whitespace-nowrap">
                      Permission
                    </span>
                    <span class="text-sm font-semibold text-gray-900 truncate">
                      {{ lvl.permissionLabel }}
                    </span>
                  </div>
                </div>
              </div>

              <h3 class="text-lg font-medium text-gray-900 mb-3">
                Assigned Users:
              </h3>

              <!-- Users side-by-side (left-to-right) -->
              <div class="flex flex-wrap gap-3">
                @for (u of lvl.users; track u.name) {
                <div
                  class="relative min-w-[240px] basis-full sm:basis-[calc(50%-0.75rem)] md:basis-[calc(33.333%-0.75rem)] lg:basis-[calc(25%-0.75rem)] bg-white border border-gray-200 rounded-lg p-3"
                >
                  <div class="flex items-center gap-2 min-w-0">
                    <strong class="text-gray-900 truncate" style="font-size: 14px">{{
                      u.name
                    }}</strong>
                    <span
                      class="px-2 py-0.5 rounded-full shrink-0"
                      style="font-size: 14px"
                      [ngClass]="statusPillClass(u.status)"
                      >{{ u.status }}</span
                    >
                  </div>
                  @if (u.comment) {
                  <div class="mt-2 text-gray-700" style="font-size: 14px">
                    {{ u.comment }}
                  </div>
                  } @if (!u.comment) {
                  <div class="text-gray-400 mt-2" style="font-size: 14px">
                    No Comments
                  </div>
                  }
                  <div class="text-gray-500 mt-1" style="font-size: 14px">
                    {{ u.date }} ; {{ u.time }}
                  </div>
                </div>
                }
              </div>
            </div>
            }
            } @else {
            <div class="text-center text-gray-500 py-4">
              <i class="pi pi-users text-2xl mb-2 block"></i>
              <p>No assigned users found</p>
            </div>
            }
          </div>
        </div>
      </div>
      <!-- Right: Meta and Comments -->
      <div class="lg:col-span-1 space-y-6">
        <div class="bg-white border border-gray-200 rounded-lg p-4 space-y-4">
          <div class="grid grid-cols-2 gap-3">
            <div>
              <div class="text-xs text-gray-500">Created Date</div>
              <div class="font-semibold text-gray-900">
                {{ formatDate(routingSlipDetails.createdOn) }}
              </div>
            </div>
            <div>
              <div class="text-xs text-gray-500">Created By</div>
              <div class="font-semibold text-gray-900">
                {{
                  routingSlipDetails.createdBy
                    ? getUserName(routingSlipDetails.createdBy)
                    : "Unknown User"
                }}
              </div>
            </div>
            <div>
              <div class="text-xs text-gray-500">Due Date</div>
              <div class="font-semibold text-gray-900">
                {{ formatDate(routingSlipDetails.dueDate) }}
              </div>
            </div>
            <!-- Review Status -->
            <!-- <div>
              <div class="text-xs text-gray-500">Status</div>
              <div class="font-semibold text-gray-900">
                {{ getReviewStatusText(routingSlipDetails.status) }}
              </div>
            </div> -->
            <div>
              <div class="text-xs text-gray-500">Status</div>
              <div class="font-semibold text-gray-900">
                {{ getStatusDescriptionText(routingSlipDetails.statusDescription) }}
              </div>
            </div>
          </div>

          <!-- <div
              class="flex items-center justify-between text-white rounded-lg px-3 py-5"
              [style.background-color]="'var(--color-background-document)'"
            >
              <div>
                <div class="text-xs pb-2">Document Name</div>
                <div>
                  {{ routingSlipDetails.documentName }}
                </div>
              </div>

              <button
                type="button"
                (click)="onViewDocument()"
                class="text-[13px] font-semibold underline"
                style="
                  color: var(--color-primary-red);
                  background: none;
                  border: none;
                  cursor: pointer;
                "
              >
                View Document
              </button>
            </div> -->

          <div
            class="text-white rounded-lg px-3 py-5 flex flex-col"
            [style.background-color]="'var(--color-background-document)'"
          >
            <!-- Row 1 -->
            <div class="text-xs pb-2">Document Name</div>

            <!-- Row 2 -->
            <div class="flex items-baseline justify-between">
              <div class="font-semibold">
                {{ routingSlipDetails.documentName }}
              </div>

              <button
                type="button"
                (click)="onViewDocument()"
                class="text-[13px] font-semibold underline"
                style="
                  color: var(--color-primary-red);
                  background: none;
                  border: none;
                  padding: 0;
                  appearance: none;
                  cursor: pointer;
                "
              >
                View Document
              </button>
            </div>
          </div>

          <!-- <button
            pButton
            type="button"
            class="p-button-outlined p-button-sm w-full"
            (click)="openUploadModal()"
          >
            Update Document
          </button> -->
        </div>
        <div class="bg-white border border-gray-200 rounded-lg p-4">
          <div class="flex items-center justify-between mb-3">
            <h4 class="font-medium text-gray-900">Comments:</h4>
            @if (showCommentButton) {
            <button
              pButton
              type="button "
              class="p-button-sm comment-button"
              label="Add New Comment"
              (click)="openCommentModal()"
            ></button>
            }
          </div>
          @if (comments.length > 0) { @for (c of comments; track $index) {
          <div class="border-t border-gray-100 pt-3 mt-3">
            <div class="text-gray-800">{{ c.text }}</div>
            <div class="text-xs text-gray-500 mt-1">
              --- By {{ c.by }} | {{ c.date }} ; {{ c.time }}
            </div>
          </div>
          } } @else {
          <div class="text-center text-gray-500 py-4">
            <i class="pi pi-comment text-2xl mb-2 block"></i>
            <p>No Comments</p>
          </div>
          }
        </div>
      </div>
    </div>
    }

    <!-- Error State -->
    @if (!loading && !routingSlipDetails) {
    <div class="max-w-xl">
      <div class="bg-white border border-gray-200 rounded-xl px-6 py-7">
        <div class="flex items-start gap-4">
          <div
            class="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-red-50 text-red-600"
          >
            <i class="pi text-lg" [ngClass]="loadErrorIcon"></i>
          </div>
          <div class="min-w-0">
            <h2 class="text-lg font-semibold text-gray-900">
              {{ loadErrorTitle }}
            </h2>
            <p class="mt-1 text-sm leading-6 text-gray-600">
              {{ loadErrorMessage }}
            </p>
            <div class="mt-5">
              <p-button
                class="buttons-details"
                label="Back to Routing Slips"
                icon="pi pi-arrow-left"
                (onClick)="onBack()"
              ></p-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
</div>

<!-- Common Modal -->
<app-modal
  [visible]="showModal"
  [modalType]="modalType"
  [title]="modalTitle"
  [submitButtonLabel]="modalSubmitButtonLabel"
  [commentInitialValue]="(modalType === 'approve' || modalType === 'reject') ? pendingDocusignApproverejectCommentForModal : ''"
  [width]="modalType === 'upload' ? '600px' : '500px'"
  [keepOpenOnSubmit]="isDocuSignSignAndSubmitModalMode"
  [submitInProgress]="isDocuSignApproveSubmitting"
  [dismissableMask]="!isDocuSignSignAndSubmitModalMode || !isDocuSignApproveSubmitting"
  [closable]="!isDocuSignSignAndSubmitModalMode || !isDocuSignApproveSubmitting"
  (visibleChange)="showModal = $event"
  (close)="onModalClose()"
  (submit)="onModalSubmit($event)"
></app-modal>

<!-- Document Viewer Modal -->
<app-document-viewer-modal
  [visible]="showDocumentViewer"
  [attachment]="currentDocument"
  [loading]="!currentDocument"
  [documentName]="documentName"
  (visibleChange)="showDocumentViewer = $event"
  (download)="onDocumentDownload($event)"
  (openInNewTab)="onDocumentOpenInNewTab($event)"
></app-document-viewer-modal>

<!-- Audit Log Modal -->
<app-audit-modal
  [(visible)]="auditDialogVisible"
  [logs]="auditData"
  [row]="selectedRow"
  [loading]="auditLoading"
  (close)="onAuditClose()"
></app-audit-modal>

<!-- Archive Confirmation Modal -->
<app-modal
  [(visible)]="showDeleteModal"
  modalType="confirm"
  title="Archive Routing Slip"
  message="Are you sure you want to archive this routing slip? This action cannot be undone."
  [confirmButtonText]="isDeleting ? 'Archiving...' : 'Confirm'"
  [confirmButtonDisabled]="isDeleting"
  cancelButtonText="Back"
  width="400px"
  (confirm)="confirmDeleteRoutingSlip()"
  (close)="cancelDeleteRoutingSlip()"
></app-modal>

<!-- Toast Messages -->
<p-toast></p-toast>
